import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from '@env/environment';

export interface DropdownOption {
  label: string;
  value: any;
}

@Injectable({
  providedIn: 'root',
})
export class RuleSetService {
  private readonly http = inject(HttpClient);
  private readonly apiBaseURL: string;

  constructor() {
    this.apiBaseURL = environment.apiEndpoint;
  }

  getRuleSetList(params: {}): Observable<any> {
    const options = {
      params: new HttpParams({ fromObject: params }),
    };
    return this.http.get<any>(this.apiBaseURL + 'ruleSet/listWithPagination', options);
  }

  getMultipleRuleSets(params: {}): Observable<any> {
    const options = {
      params: new HttpParams({ fromObject: params }),
    };
    return this.http.get<any>(this.apiBaseURL + 'ruleSet/getMultipleRuleSets', options);
  }

  getOneByName(params: {}): Observable<any> {
    const options = {
      params: new HttpParams({ fromObject: params }),
    };
    return this.http.get<any>(this.apiBaseURL + 'ruleSet/dropDown/getOneByName', options);
  }

  getRuleSetDetails(id: string): Observable<any> {
    return this.http.get<any>(this.apiBaseURL + 'ruleSet/' + id);
  }

  createRuleSet(formData: any): Observable<any> {
    return this.http.post<any>(this.apiBaseURL + 'ruleSet', formData);
  }

  updateRuleSet(id: any, formData: any): Observable<any> {
    return this.http.put<any>(this.apiBaseURL + 'ruleSet/' + id, formData);
  }

  updateRuleSetStatus(id: any, status: number): Observable<any> {
    return this.http.patch<any>(this.apiBaseURL + 'ruleSet/' + id + '/status', { status });
  }

  deleteRuleSet(id: any): Observable<any> {
    return this.http.delete<any>(this.apiBaseURL + 'ruleSet/' + id);
  }
}
